import {Component, effect, input} from '@angular/core';
import {TableComponent} from "../../../../../utils/table/table.component";
import {AResourceTableComponent} from "../../../../../AResourceTableComponent";
import {ApiInterfaceCustomerModel} from "../../../../../../models/resources/api-interface-customer.model";
import {ApiInterfaceModel} from "../../../../../../models/resources/api-interface.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormGroupHelper} from "../../../../../../helpers/form-group-helper";
import {TableColumnModel} from "../../../../../../models/table-column.model";
import {ApiInterfaceCustomerService} from "../../../../../../services/resources/api-interface-customer.service";
import {HttpErrorsService} from "../../../../../../services/utils/http-errors.service";
import {CustomNotificationService} from "../../../../../../services/utils/custom-notification.service";
import {castCompanyTypeEnum, CompanyType} from "../../../../../../enums/company-type";

@Component({
  selector: 'app-api-interface-customer-table',
  imports: [
    TableComponent
  ],
  templateUrl: './api-interface-customer-table.component.html',
  styleUrl: './api-interface-customer-table.component.scss',
})
export class ApiInterfaceCustomerTableComponent extends AResourceTableComponent<ApiInterfaceCustomerModel> {
  apiInterface = input<ApiInterfaceModel>()

  filterFormGroup: FormGroup =
    FormGroupHelper.createFilterFormGroup(this.formBuilder,
      [
        'company',
        'companyType'
      ]
    )

  tableColumns: TableColumnModel[] = [
    {
      name: 'TYPE',
      selector: [{selector: 'customer.companyType'}],
      filterFormControl: this.filterFormGroup.get('companyType'),
      filterFormControlLabel: 'TYPE',
      filterUrlParam: 'company-type',
      enum: CompanyType,
      enumCastFunction: castCompanyTypeEnum
    },
    {
      name: 'CUSTOMERS.COMPANY',
      selector: [{selector: 'customer.company'}],
      filterFormControl: this.filterFormGroup.get('company'),
      filterFormControlLabel: 'CUSTOMERS.COMPANY',
      filterUrlParam: 'company'
    },
    // {
    //   name: 'CUSTOMERS.PERSON_NAME',
    //   selector: [
    //     { selector: 'person.name' }
    //   ],
    //   filterFormControl: this.filterFormGroup.get('name'),
    //   filterFormControlLabel: 'NAME',
    //   filterUrlParam: 'name'
    // },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          customLink: '/customers/{customer.id}',
          linkTarget: '_blank'
        },
        // {
        //   iconClass: 'fas fa-trash fa-lg',
        //   floating: true,
        //   outlined: true,
        //   color: 'danger',
        //   isDelete: true,
        //   onClick: ($event) => this.delete($event)
        // },
      ],
    },
  ];

  constructor(
    formBuilder: FormBuilder,
    public apiInterfaceCustomerService: ApiInterfaceCustomerService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService
  ) {
    super(formBuilder, apiInterfaceCustomerService, httpErrorsService, notificationService, 'API_INTERFACE_CUSTOMERS')

    effect(() => {
      if (!this.apiInterface())
        return

      this.apiInterfaceCustomerService.setApiInterfaceId(this.apiInterface()!.id);
    })
  }

  override ngOnInit() {
    if (!this.apiInterface())
      this.apiInterfaceCustomerService.removeApiInterfaceId()

    super.ngOnInit()
  }
}
